import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const uploadImages = async (data) => {
  await apiClient.setHeaderFormData();
  const response = await apiClient.request('POST', '/admin/upload/question-images', data);
  if (!isApiResponseError(response)) {
    apiClient.resetHeader();
    return response.data;
  } else {
    apiClient.resetHeader();
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const getSignedURL = async (body) => {
  const response = await apiClient.request('POST', '/admin/upload/signed-url', body);
  if (!isApiResponseError(response)) {
    return response.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const getImages = async (url, etag) => {
  try {
    await apiClient.setHeaderImage(url, etag);
    const response = await apiClient.request('GET', '', null, {
      responseType: 'blob',
    });
    if (!isApiResponseError(response)) {
      apiClient.resetHeader();
      return response.data;
    } else {
      apiClient.resetHeader();
      throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
    }
  } catch (error) {
    apiClient.resetHeader();
    throw validateMessageResponse(error.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const resumableSession = async (data) => {
  const response = await apiClient.request('POST', '/admin/file-samples/resumable-session', data);
  if (!isApiResponseError(response)) {
    return response.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const resumableUpload = async (data) => {
  await apiClient.setHeaderFormData();
  const response = await apiClient.request('PUT', '/admin/file-samples/resumable-upload', data);
  apiClient.resetHeader();
  if (!isApiResponseError(response)) {
    return response.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
